<template>
  <div class="dashboard-block">
    <div class="row row-clear-sm-6-md-4">
      <div :class="$paymentsModuleEnabled ? `col-sm-6 col-md-4` : `col-sm-6`">
        <div class="dashboard-widget-overview">
          <span class="amount" v-if="$costReferences && widgets.pending_total && !$isAflClub" >{{ widgets.pending_total | currency(widgets.currency) }}</span>
          {{ widgets.pending_count }} Pending {{ $t('Requests') }} this week
        </div>
      </div>
      <div :class="$paymentsModuleEnabled ? `col-sm-6 col-md-4` : `col-sm-6`">
        <div class="dashboard-widget-overview">
          <span class="amount" v-if="$costReferences && widgets.completed_total && !$isAflClub" >{{ widgets.completed_total | currency(widgets.currency) }}</span>
          {{ widgets.completed_count }} Completed Bookings this week
        </div>
      </div>
      <div :class="$paymentsModuleEnabled ? `col-sm-6 col-md-4` : `col-sm-6`">
        <div class="dashboard-widget-overview">
          <span class="amount" v-if="$costReferences && widgets.active_total && !$isAflClub" >{{ widgets.active_total | currency(widgets.currency) }}</span>
          {{ widgets.active_count }} Active Bookings this week
        </div>
      </div>
    </div>

    <div class="row">
      <div :class="[vettingTalentAndManagersClass]" v-if="haveVettingTalent">
        <router-link :to="{ name: 'talent.index', params: { status: 'unverified' } }" class="btn btn-block btn-default-outline">
          {{ widgets.vetting_talent }} Unverified {{ $starLabelPlural }} Pending <i class="fa fa-chevron-right"></i>
        </router-link>
      </div>

      <div :class="[vettingTalentAndManagersClass]" v-if="haveVettingManagers" >
        <router-link :to="{ name: 'managers.index', params: { status: 'unverified' } }" class="btn btn-block btn-default-outline">
          {{ widgets.vetting_managers }} Unverified Managers Pending <i class="fa fa-chevron-right"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('dashboard', ['widgets']),

    haveVettingTalent () {
      return this.widgets.vetting_talent > 0
    },

    haveVettingManagers () {
      return this.widgets.vetting_managers > 0
    },

    vettingTalentAndManagersClass () {
      if (this.haveVettingTalent && this.haveVettingManagers) {
        return 'col-sm-6'
      }

      return 'col-sm-12'
    }
  },

  created () {
    this.getWidgets()
  },

  methods: mapActions('dashboard', ['getWidgets'])
}
</script>
